var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.MODAL_ID,
            "header-class": "draggable-modal",
            title: "Make Template Image Editable",
            size: "lg",
            "hide-footer": "",
            "no-close-on-backdrop": "",
          },
          on: { show: _vm.onModalOpen, hide: _vm.onModalHide },
        },
        [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center mb-1",
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "mb-0",
                      attrs: { for: "backgroundImageSelect" },
                    },
                    [
                      _vm._v(
                        "Templates (" +
                          _vm._s(_vm.selectedTemplates.length) +
                          " selected)"
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "a",
                      {
                        staticClass: "text-secondary small mr-2",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.selectAllTemplates.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("Select all")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "text-secondary small",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.clearAllTemplates.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("Clear")]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("Multiselect", {
                attrs: {
                  id: "backgroundImageSelect",
                  options: _vm.backgroundImages,
                  multiple: true,
                  "close-on-select": false,
                  "clear-on-select": false,
                  placeholder: "Select templates",
                  label: "text",
                  "track-by": "value",
                },
                on: { input: _vm.onSelectedTemplatesChange },
                model: {
                  value: _vm.selectedTemplates,
                  callback: function ($$v) {
                    _vm.selectedTemplates = $$v
                  },
                  expression: "selectedTemplates",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.selectedTemplates.length > 0
            ? _c(
                "div",
                {
                  staticClass:
                    "template-navigation mb-3 p-2 border rounded d-flex justify-content-between align-items-center bg-light",
                },
                [
                  _c("div", [
                    _c("strong", [
                      _vm._v(
                        "Template " +
                          _vm._s(_vm.currentTemplateIndex + 1) +
                          " of " +
                          _vm._s(_vm.selectedTemplates.length)
                      ),
                    ]),
                    _vm._v(
                      " — " +
                        _vm._s(
                          _vm.selectedTemplates[_vm.currentTemplateIndex]?.text
                        ) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex align-items-center gap-1" },
                    _vm._l(_vm.selectedTemplates, function (template, index) {
                      return _c(
                        "button",
                        {
                          key: template.value,
                          staticClass:
                            "btn btn-sm rounded-circle d-flex align-items-center justify-content-center p-0",
                          class:
                            index === _vm.currentTemplateIndex
                              ? "btn-success text-white"
                              : "btn-outline-secondary",
                          staticStyle: {
                            width: "24px",
                            height: "24px",
                            "font-size": "12px",
                            "margin-left": "4px",
                          },
                          on: {
                            click: function ($event) {
                              _vm.currentTemplateIndex = index
                            },
                          },
                        },
                        [
                          _vm.hasConfigForTemplate(template.value) &&
                          index !== _vm.currentTemplateIndex
                            ? _c("i", { staticClass: "bi bi-check2" })
                            : _c("span", [_vm._v(_vm._s(index + 1))]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "b-card",
                { attrs: { "no-body": "" } },
                [
                  _c(
                    "b-tabs",
                    { attrs: { pills: "", card: "", fill: "" } },
                    [
                      _c(
                        "b-tab",
                        {
                          attrs: { active: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function () {
                                return [
                                  _c("i", { staticClass: "bi bi-fonts" }),
                                  _vm._v(" Text Blocks\n            "),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _vm.selectedBackgroundImageIndex !== "none" &&
                          _vm.selectedImage
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text-blocks-select-header",
                                    },
                                    [
                                      _c("label", { staticClass: "mb-1" }, [
                                        _vm._v(
                                          "Select Text Blocks to Make Editable"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              modifiers: { hover: true },
                                            },
                                          ],
                                          staticClass:
                                            "copy-text-blocks-header-btn",
                                          attrs: {
                                            type: "button",
                                            title: "Copy to clipboard",
                                            "aria-label": "Copy to clipboard",
                                            disabled:
                                              _vm.isLoadingTextBlocks ||
                                              !_vm.hasTextBlocksToCopy,
                                          },
                                          on: {
                                            click:
                                              _vm.copyTextBlocksToClipboard,
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "bi bi-clipboard",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("Multiselect", {
                                    attrs: {
                                      options: _vm.isLoadingTextBlocks
                                        ? []
                                        : _vm.detectedTextBlocks,
                                      multiple: true,
                                      "close-on-select": false,
                                      "clear-on-select": false,
                                      placeholder: _vm.isLoadingTextBlocks
                                        ? "Detecting text blocks..."
                                        : "Select text blocks",
                                      disabled: _vm.isLoadingTextBlocks,
                                    },
                                    model: {
                                      value: _vm.selectedTextBlocks,
                                      callback: function ($$v) {
                                        _vm.selectedTextBlocks = $$v
                                      },
                                      expression: "selectedTextBlocks",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.isLoadingTextBlocks
                                    ? _c(
                                        "div",
                                        { staticClass: "text-center mt-3" },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "spinner-border spinner-border-sm",
                                            attrs: { role: "status" },
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "ml-2" }, [
                                            _vm._v("Detecting text blocks..."),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                { staticClass: "text-muted text-center py-3" },
                                [
                                  _vm._v(
                                    "\n              Select an image to detect text blocks.\n            "
                                  ),
                                ]
                              ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function () {
                                return [
                                  _c("i", { staticClass: "bi bi-cursor" }),
                                  _vm._v(" Area Selection\n            "),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _vm.selectedBackgroundImageIndex !== "none" &&
                          _vm.selectedImage
                            ? _c("div", [
                                _c("div", { staticClass: "form-group mb-2" }, [
                                  _c("span", [
                                    _vm._v(
                                      "Select the areas to make editable:"
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "text-removal-body" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex flex-column gap-3",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "image-container-wrapper",
                                            on: {
                                              mousedown: _vm.startSelection,
                                              mousemove: _vm.updateSelection,
                                              mouseup: _vm.endSelection,
                                              mouseleave: _vm.endSelection,
                                              dragstart: function ($event) {
                                                $event.preventDefault()
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "image-container",
                                                class: {
                                                  disabled: _vm.isLoading,
                                                },
                                                on: {
                                                  dragstart: function ($event) {
                                                    $event.preventDefault()
                                                  },
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  ref: "zoomedImage",
                                                  staticClass: "zoomed-image",
                                                  attrs: {
                                                    src: _vm.selectedImage,
                                                    draggable: "false",
                                                  },
                                                }),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("canvas", {
                                              ref: "selectionCanvas",
                                              staticClass: "selection-canvas",
                                              staticStyle: {
                                                "pointer-events": "none",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _vm.hasSelection ||
                                            (_vm.isSelecting &&
                                              _vm.imageSelection.width > 0 &&
                                              _vm.imageSelection.height > 0)
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "selection-preview",
                                                    class: {
                                                      "align-left":
                                                        _vm.isMouseOnRightSide,
                                                    },
                                                  },
                                                  [
                                                    _vm.previewImage
                                                      ? _c("img", {
                                                          staticClass:
                                                            "preview-image",
                                                          attrs: {
                                                            src: _vm.previewImage,
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "preview-info",
                                                      },
                                                      [
                                                        _c("p", [
                                                          _vm._v(
                                                            "\n                          Size: " +
                                                              _vm._s(
                                                                Math.round(
                                                                  _vm
                                                                    .imageSelection
                                                                    .width
                                                                )
                                                              ) +
                                                              "x" +
                                                              _vm._s(
                                                                Math.round(
                                                                  _vm
                                                                    .imageSelection
                                                                    .height
                                                                )
                                                              ) +
                                                              "px\n                          "
                                                          ),
                                                          _vm.shouldShowSizeWarning
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name: "b-tooltip",
                                                                      rawName:
                                                                        "v-b-tooltip.hover",
                                                                      modifiers:
                                                                        {
                                                                          hover: true,
                                                                        },
                                                                    },
                                                                  ],
                                                                  staticClass:
                                                                    "size-warning",
                                                                  attrs: {
                                                                    title:
                                                                      "Selecting an area with a width or height greater than 1024px may result in blurry output.",
                                                                  },
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fas fa-exclamation-circle",
                                                                  }),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("p", [
                                                          _vm._v(
                                                            "Position: (" +
                                                              _vm._s(
                                                                Math.round(
                                                                  _vm
                                                                    .imageSelection
                                                                    .left
                                                                )
                                                              ) +
                                                              ", " +
                                                              _vm._s(
                                                                Math.round(
                                                                  _vm
                                                                    .imageSelection
                                                                    .top
                                                                )
                                                              ) +
                                                              ")"
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-between align-items-center p-2 cursor-pointer border rounded mt-2 mb-2",
              on: {
                click: function ($event) {
                  _vm.isCollapsed = !_vm.isCollapsed
                },
              },
            },
            [
              _c("h6", { staticClass: "mb-0" }, [
                _c("span", [
                  _c("i", { staticClass: "bi bi-sliders mr-1" }),
                  _vm._v("Options"),
                ]),
              ]),
              _vm._v(" "),
              _c("i", {
                class: [
                  "fas",
                  _vm.isCollapsed ? "fa-chevron-down" : "fa-chevron-up",
                ],
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isCollapsed,
                  expression: "!isCollapsed",
                },
              ],
            },
            [
              _c("div", { staticClass: "row mb-3" }, [
                _c(
                  "div",
                  { staticClass: "col-md-6" },
                  [
                    _c("label", [_vm._v("For infill, use:")]),
                    _vm._v(" "),
                    _c("b-form-select", {
                      attrs: { options: _vm.infillMethodOptions },
                      model: {
                        value: _vm.infillMethod,
                        callback: function ($$v) {
                          _vm.infillMethod = $$v
                        },
                        expression: "infillMethod",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-6" },
                  [
                    _c("label", [_vm._v("Template action:")]),
                    _vm._v(" "),
                    _c("b-form-select", {
                      attrs: { options: _vm.templateActionOptions },
                      model: {
                        value: _vm.templateAction,
                        callback: function ($$v) {
                          _vm.templateAction = $$v
                        },
                        expression: "templateAction",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mb-3" },
                [
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: { value: true, "unchecked-value": false },
                      model: {
                        value: _vm.translateAfterExtract,
                        callback: function ($$v) {
                          _vm.translateAfterExtract = $$v
                        },
                        expression: "translateAfterExtract",
                      },
                    },
                    [_vm._v("\n          Translate extracted text\n        ")]
                  ),
                  _vm._v(" "),
                  _vm.translateAfterExtract
                    ? _c(
                        "div",
                        { staticClass: "mt-2" },
                        [
                          _c("label", [_vm._v("Target language(s):")]),
                          _vm._v(" "),
                          _c("Multiselect", {
                            staticClass: "multiselect-translation",
                            attrs: {
                              options: _vm.availableLanguages,
                              multiple: true,
                              "close-on-select": true,
                              taggable: false,
                              placeholder: "Select language(s)...",
                            },
                            model: {
                              value: _vm.translateTargetLanguages,
                              callback: function ($$v) {
                                _vm.translateTargetLanguages = $$v
                              },
                              expression: "translateTargetLanguages",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mb-3" },
                [
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: { value: true, "unchecked-value": false },
                      model: {
                        value: _vm.showAiEditorAfterMakeEditable,
                        callback: function ($$v) {
                          _vm.showAiEditorAfterMakeEditable = $$v
                        },
                        expression: "showAiEditorAfterMakeEditable",
                      },
                    },
                    [
                      _vm._v(
                        "\n          Show AI image editor after making text editable\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex justify-content-between mt-2" }, [
            _c("div", { staticClass: "d-flex gap-2" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-secondary mr-2",
                  attrs: {
                    type: "button",
                    disabled: _vm.currentTemplateIndex === 0,
                  },
                  on: {
                    click: function ($event) {
                      _vm.currentTemplateIndex--
                    },
                  },
                },
                [
                  _c("i", { staticClass: "bi bi-chevron-left" }),
                  _vm._v(" Back\n        "),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-secondary",
                  attrs: {
                    type: "button",
                    disabled:
                      _vm.currentTemplateIndex >=
                      Math.max(0, _vm.selectedTemplates.length - 1),
                  },
                  on: {
                    click: function ($event) {
                      _vm.currentTemplateIndex++
                    },
                  },
                },
                [
                  _vm._v("\n          Next "),
                  _c("i", { staticClass: "bi bi-chevron-right" }),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-success",
                attrs: {
                  type: "button",
                  disabled:
                    _vm.selectedTemplates.length === 0 ||
                    _vm.isLoading ||
                    _vm.isIdentifyingTextElements,
                },
                on: {
                  click: function ($event) {
                    return _vm.handleRemove()
                  },
                },
              },
              [
                (_vm.isLoading || _vm.isIdentifyingTextElements) &&
                !_vm.expandInProgress
                  ? _c("span", {
                      staticClass: "spinner-border spinner-border-sm",
                      attrs: { role: "status", "aria-hidden": "true" },
                    })
                  : _c("i", { staticClass: "bi bi-pencil" }),
                _vm._v(
                  "\n        " +
                    _vm._s(
                      (_vm.isLoading || _vm.isIdentifyingTextElements) &&
                        !_vm.expandInProgress
                        ? "Processing..."
                        : `Start (${_vm.selectedTemplates.length} templates)`
                    ) +
                    "\n      "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.selections.length > 0
            ? _c("div", { staticClass: "selections-list mt-3" }, [
                _c("h6", [
                  _vm._v(
                    "Selected Areas (" + _vm._s(_vm.selections.length) + ")"
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex flex-wrap" },
                  _vm._l(_vm.selections, function (selection, index) {
                    return _c(
                      "div",
                      {
                        key: `area-${index}`,
                        staticClass: "selection-item mr-3 mb-2",
                        class: { active: index === _vm.currentSelectionIndex },
                        on: {
                          click: function ($event) {
                            return _vm.selectArea(index)
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "selection-thumbnail",
                          attrs: { src: selection.previewImage },
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-danger",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.removeSelection(index)
                              },
                            },
                          },
                          [_vm._v("\n            ×\n          ")]
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-warning mt-2",
                    on: { click: _vm.clearAllSelections },
                  },
                  [_vm._v("\n        Clear All\n      ")]
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }